module.exports = __webpack_public_path__ + "img/banner-2024-10-03-1190x250.3bfc4f68.gif";